import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  getToken(): string | null {
    const token = window.sessionStorage.getItem('AGE_AUTH');
    return token;
  }

  saveToken(token: string): void {
    window.sessionStorage.setItem('AGE_AUTH', token);
  }

  destroyToken(): void {
    window.sessionStorage.removeItem('AGE_AUTH');
  }

    getRoles(): string {
        const token: string = window.sessionStorage.getItem('AGE_AUTH')??"";

    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).roles;
    }
    else { return 'All'; }
  }

  public urlBase64Decode(str: string): string {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0: { break; }
      case 2: { output += '=='; break; }
      case 3: { output += '='; break; }
      default: {
        throw 'Illegal base64url string!';
      }
    }
    return this.b64DecodeUnicode(output);
  }

 
  private b64decode(str: string): string {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output: string = '';

    str = String(str).replace(/=+$/, '');

    if (str.length % 4 == 1) {
      throw new Error("The string to be decoded is not correctly encoded.");
    }

    for (
      let bc: number = 0, bs: any, buffer: any, idx: number = 0;
      buffer = str.charAt(idx++);
      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
    ) {
      buffer = chars.indexOf(buffer);
    }
    return output;
  }

  private b64DecodeUnicode(str: any) {
    return decodeURIComponent(Array.prototype.map.call(this.b64decode(str), (c: any) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  public decodeToken(token: String): any {
    let parts = token.split('.');

    if (parts.length !== 3) {
      throw new Error('JWT must have 3 parts');
    }

    let decoded = this.urlBase64Decode(parts[1]);
    if (!decoded) {
      throw new Error('Cannot decode the token');
    }
    
    return JSON.parse(decoded);
  }

  public getTokenExpirationDate(token: string): Date | null {
    const decoded: any = this.decodeToken(token);
  
    if (!decoded?.exp) {
      return null;
    }
  
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  public isTokenExpired(token: string, offsetSeconds: number = 0): boolean {
    const date = this.getTokenExpirationDate(token);
  
    if (!date) {
      return true; // expired when no exp
    }
  
    const now = Date.now() + offsetSeconds * 1000;
    return date.valueOf() <= now;
  }
}
